/**
 * Document patches and the fine-tune action log.
 *
 * A patched document is NOT a fork. The composition still compiles; the
 * user's edits are an ordered, append-only ACTION LOG replayed over the
 * compiled IR before assembly (compile → replay → assemble), so numbering
 * and cross-references are computed over the edited tree, and form edits
 * (draft) and text edits (fine-tune) co-exist: every recompile re-replays
 * the log.
 *
 * Two layers:
 *
 *  - `DocumentPatch` — one concrete edit, the engine's input
 *    (`applyPatches`). Anchored to a node of the COMPILED BASE by
 *    `instanceId` [+ `sectionId`] [+ `path`], or to the output of an
 *    earlier patch (`{ fromPatch }`), and carrying the fingerprint of the
 *    base node it was made against.
 *  - `ActionLogEntry` — one user action (`replayLog`). Content actions map
 *    1:1 onto patches; `undo` and `rebase` entries act on earlier entries.
 *    Nothing is ever deleted from the log: undo is itself an entry.
 *
 * Fingerprints are always of the node AS COMPILED (never as already
 * patched), so "this patch conflicts" means exactly "the compiled text
 * under it changed since the user made it" — independent of what other
 * entries did. A conflict is never applied; a human resolves it (keep as
 * text / drop / re-anchor), and that resolution is another log entry.
 */
export const ACTION_LOG_SCHEMA = 'regta.document.actionlog';
export const ACTION_LOG_VERSION = 1;
/** The flag a patched legal-plane document carries. */
export const DEVIATION_LABEL = 'Avviker från standardmallen';
/** Ref of the section an `insertClause` creates. */
export const insertedSectionRef = (patchId) => `patch-${patchId}`;
/* ------------------------------------------------------------------ */
/* Own fields (ADR-0102 addendum)                                      */
/* ------------------------------------------------------------------ */
/**
 * Reserved key prefix of own fields. Their values live in the host's form
 * values under these keys; no block slot may use the prefix.
 */
export const CUSTOM_FIELD_PREFIX = 'custom_';
/** Form group id / title the own fields appear under. */
export const CUSTOM_FIELDS_GROUP_ID = 'custom-fields';
export const CUSTOM_FIELDS_GROUP_TITLE = 'Egna uppgifter';
export const isCustomFieldKey = (key) => key.startsWith(CUSTOM_FIELD_PREFIX);
//# sourceMappingURL=types.js.map